import { render, staticRenderFns } from "./CollapseQuestionSection.vue?vue&type=template&id=6139fc36&scoped=true"
import script from "./CollapseQuestionSection.vue?vue&type=script&lang=js"
export * from "./CollapseQuestionSection.vue?vue&type=script&lang=js"
import style0 from "./CollapseQuestionSection.vue?vue&type=style&index=0&id=6139fc36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6139fc36",
  null
  
)

export default component.exports